import { Language } from './base';

const pdash = () => import('../translations/pdash/es-CO.json');
const webActivities = () => import('../translations/web-activities/es-CO.json');
const rdashTranslatables = () => import('../translations/rdash-translatables/es-CO.json');

export default new Language({
    code: 'es-CO',
    locale: 'es-CO',
    localName: 'Colombiano',
    englishName: 'Colombian',
    territory: 'CO',
    notLoadedNamespaces: { pdash, webActivities, rdashTranslatables },
});
